import download from "downloadjs";
import axios from "axios";
import { toString } from "lodash";
import {
  getDocumentEmailUrl,
  getSignDocumentEmailUrl,
  getSrmPdfUrl,
  getSrmSignDocUrl
} from "./urls";

export function base64ToArrayBuffer(b64: string) {
  const decodedData = atob(b64);
  return Uint8Array.from(decodedData, c => c.charCodeAt(0)).buffer;
}

export type DocumentActionType =
  | "workorder"
  | "workorderestimate"
  | "contract"
  | "invoice"
  | "workorderinspection"
  | "repairinspection"
  | "reservations"
  | "quotes"
  | "all-in-one-transactions";

class DocumentActions {
  documentType: DocumentActionType;
  documentNumber: string;
  documentSubNumber: string;

  constructor(
    documentType: DocumentActionType,
    documentNumber: string,
    documentSubNumber?: string
  ) {
    this.documentType = documentType;
    this.documentNumber = toString(documentNumber) || null;
    this.documentSubNumber = toString(documentSubNumber) || null;
  }

  private async getDocumentBinaryData() {
    const url = getSrmPdfUrl({
      type: this.documentType,
      id: this.documentNumber,
      subId: this.documentSubNumber
    });

    const response = await axios.get(url, {
      responseType: "arraybuffer"
    });
    return response.data;
  }

  private async getSignedDocumentBinaryData(data) {
    const url = getSrmSignDocUrl({
      type: this.documentType,
      id: this.documentNumber,
      subId: this.documentSubNumber
    });
    const response = await axios.put(
      url,
      { ...data },
      { responseType: "arraybuffer" }
    );
    return response.data;
  }

  getDocumentPdfData = async () => {
    return await this.getDocumentBinaryData();
  };

  getSignedDocumentPdfData = async data => {
    return await this.getSignedDocumentBinaryData(data);
  };

  downloadDocumentPdf = async () => {
    const blob = await this.getDocumentPdfData();
    download(blob, this.documentNumber + ".pdf", "application/pdf");
  };

  downloadSignedDocumentPdf = async data => {
    const blob = await this.getSignedDocumentPdfData(data);
    download(blob, this.documentNumber + ".pdf", "application/pdf");
  };

  printDocument = async () => {
    const blob = await this.getDocumentPdfData();
    let pdfURL = URL.createObjectURL(blob);
    let a = document.createElement("a");
    a.href = pdfURL;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => URL.revokeObjectURL(pdfURL), 1000);
  };

  sendDocumentEmail = async emailTo => {
    const url = getDocumentEmailUrl({
      type: this.documentType,
      id: this.documentNumber,
      subId: this.documentSubNumber
    });

    let emailResponse = await axios.post(url, { emailTo: emailTo });
    return emailResponse;
  };

  sendSignedDocumentEmail = async data => {
    const url = getSignDocumentEmailUrl({
      type: this.documentType,
      id: this.documentNumber,
      subId: this.documentSubNumber
    });

    let emailResponse = await axios.post(url, data);
    return emailResponse;
  };
}

export default DocumentActions;
